<template>
  <div id="grid-documento-diario-acuerdo">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            label="Nivel"
            data-vv-name="listaNiveles"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoMaterialValue"
            :items="tipoMaterialSelect"
            label="Tipo de material"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo de prueba"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="areaValue"
            :items="areaSelect"
            label="Area"
            item-text="nombre"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoDocumentoValue"
            :items="tipoDocumentoSelect"
            label="Tipo de documento"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterDoc()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.subitem.nivel }}</td>
              <td class="text-xs-left">
                {{ props.item.subitem.tipoMaterial }}
              </td>
              <td class="text-xs-left">{{ props.item.subitem.tipoPrueba }}</td>
              <td class="text-xs-left">{{ props.item.subitem.area }}</td>
              <td class="text-xs-left">
                {{ props.item.subitem.tipoDocumento }}
              </td>
              <td
                v-if="bloqueo || (!bloqueo && idEstado != 5 && idEstado != 1)"
                class="text-xs-left"
              >
                {{ props.item.cantidad }}
              </td>
              <td
                v-if="bloqueo || (!bloqueo && idEstado != 5 && idEstado != 1)"
                class="text-xs-left"
              >
                {{ props.item.fechaInicio }}
              </td>
              <td>
                <v-text-field
                  v-if="!bloqueo && (idEstado == 5 || idEstado == 1)"
                  label="0"
                  :value="props.item.cantidad"
                  @blur="saveCantidad(props.item.id, $event)"
                  @keypress="restrictChars($event)"
                  id="cantidad"
                  solo
                ></v-text-field>
              </td>
              <!-- <td>
                <v-text-field 
                v-if="!bloqueo && (idEstado == 5 || idEstado == 1)" 
                 label="10-10-2019"
                  :value="props.item.fechaInicio"                
                  @blur="saveFechaInicio(props.item.id,$event)"
                  id="fechaInicio"                
                solo></v-text-field>
              </td>   -->
              <td>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-if="!bloqueo && (idEstado == 5 || idEstado == 1)"
                      :value="fechaInicioValue[props.item.id]"
                      :label="props.item.fechaInicio"
                      readonly
                      v-on="on"
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fechaInicioValue[props.item.id]"
                    no-title
                    :date-format="(date) => new Date(date).toDateString()"
                    locale="es"
                    first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        saveFechaInicio(
                          props.item.id,
                          fechaInicioValue[props.item.id]
                        )
                      "
                      >OK</v-btn
                    ></v-date-picker
                  >
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <!-- dialogo    -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Esta seguro?</v-card-title>
          <v-card-text>Esta seguro que desea realizar esta accion.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="dialog = false"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogo    -->
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
export default {
  name: "grid-documento-diario-acuerdo",
  components: {
    Loading,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      dialog: false,
      idEstado: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      contratoId: "",
      itemsProgreso: [],
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Tipo de Material", sortable: false, value: "tipoDocumento" },
        { text: "Tipo de Prueba", sortable: false, value: "fechaEntrega" },
        { text: "Area", sortable: false, value: "fechaMaqueta" },
        { text: "Tipo Documento/Forma", sortable: false, value: "fechaAcceso" },
        { text: "Cantidad", sortable: false, value: "fechaActualizacion" },
        { text: "Fecha de inicio", sortable: false, value: "fechaInicio" },
      ],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsDocumento: [],
      tipoMaterialSelect: [],
      tipoPruebaSelect: [],
      tipoDocumentoValue: null,
      areaSelect: [],
      nivelSelect: [],
      nivelValue: null,
      tipoMaterialValue: null,
      tipoPruebaValue: null,
      tipoDocumentoSelect: [],
      areaValue: null,
      filter: false,
      date: "",
    };
  },
  created() {
    this.loading = true;
    this.loadData();
  },

  mounted() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.bloqueoEdicion(this.usuarioLoggedTipe);
  },
  computed: {},
  methods: {
    //   formatofechaInicioValue(f) {
    //   // Convierte un texto de la forma 2017/01/10 a la forma
    //   return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    // },

    restrictChars($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
    async loadDocumentosFilter() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        material:
          this.tipoMaterialValue && this.tipoMaterialValue != null
            ? this.tipoMaterialValue
            : null,
        prueba:
          this.tipoPruebaValue && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        tipoDocumento:
          this.tipoDocumentoValue && this.tipoDocumentoValue != null
            ? this.tipoDocumentoValue
            : null,
        area: this.areaValue && this.areaValue != null ? this.areaValue : null,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
        idAcuerdo: this.ultimoAcuerdo.id,
      };
      return await axios

        .post("/acuerdos/detalle/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadData() {
      this.ultimoAcuerdo = await this.loadUltimoAcuerdo();
      this.loading = true;
      this.idEstado = this.ultimoAcuerdo.idEstado;
      this.itemsDocumento = await this.loadDocumentosFilter();
      this.loading = false;
      if (this.itemsDocumento.length > 0) {
        this.loadNivelSelect();
        this.loadMaterialSelect();
        this.loadPruebaSelect();
        this.loadAreaSelect();
        this.loadDocumentoSelect();
        //this.$parent.$parent.bloqueoReloadOff();
      }
    },
    async loadUltimoAcuerdo() {
      let that = this;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let conId = this.$store.getters.contratoStored;
      return await axios
        .get("/acuerdo/ultimo/contrato/" + conId + "/" + subProceso)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          return [];
        });
    },
    loadNivelSelect() {
      let niv = [];
      this.itemsDocumento.forEach(function (d) {
        let index = niv.findIndex((x) => x.nivel == d.subitem.nivel);
        if (index === -1) {
          niv.push(d.subitem.nivel);
        }
      });
      this.nivelSelect = niv;
    },

    loadMaterialSelect() {
      let mat = [];
      this.itemsDocumento.forEach(function (d) {
        let index = mat.findIndex(
          (x) => x.tipoMaterial == d.subitem.tipoMaterial
        );
        if (index === -1) {
          mat.push(d.subitem.tipoMaterial);
        }
      });
      this.tipoMaterialSelect = mat;
    },
    loadPruebaSelect() {
      let pru = [];
      this.itemsDocumento.forEach(function (d) {
        let index = pru.findIndex((x) => x.tipoPrueba == d.subitem.tipoPrueba);
        if (index === -1) {
          pru.push(d.subitem.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = pru;
    },
    loadDocumentoSelect() {
      let doc = [];
      this.itemsDocumento.forEach(function (d) {
        let index = doc.findIndex(
          (x) => x.tipoDocumento == d.subitem.tipoDocumento
        );
        if (index === -1) {
          doc.push(d.subitem.tipoDocumento);
        }
      });
      this.tipoDocumentoSelect = doc;
    },
    loadAreaSelect() {
      let are = [];
      this.itemsDocumento.forEach(function (d) {
        let index = are.findIndex((x) => x.area == d.subitem.area);
        if (index === -1) {
          are.push(d.subitem.area);
        }
      });
      this.areaSelect = are;
    },

    loadSelected() {},
    clear() {
      this.nivelValue = "";
      this.tipoDocumentoValue = "";
      this.tipoMaterialValue = "";
      this.tipoPruebaValue = "";
      this.areaValue = "";
      this.loadData();
    },
    //SOLO NUMEROS
    bloqueoEdicion(tip) {
      if (tip == "AGENCIA") {
        this.bloqueo = true;
      }
      if (tip == "PROVEEDOR") {
        this.bloqueo = false;
      }
      return this.bloqueo;
    },

    saveFechaInicio(idIn, fecha) {
      let fechaFormateada = this.formatoFecha(fecha);
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        fechaInicio: fechaFormateada,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      axios
        .put("/acuerdo/update/" + idIn, this.body)
        .then(function (response) {
          window.getApp.$emit("APP_SAVE");
          response.data;
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
        });
    },
    saveCantidad(idIn, e) {
      let cant = e.currentTarget._value;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        cantidad: cant,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      axios
        .put("/acuerdo/update/" + idIn, this.body)
        .then(function (response) {
          window.getApp.$emit("APP_SAVE");
          response.data;
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
        });
    },

    filterDoc() {
      this.filter = true;
      this.loadData();
    },
  },
};
</script>
